import VoiceSelectorModalBase from "@/components/modal/voice-selector/base/voice-selector-modal-base";
import { VoiceModel } from "@/actions/db/get-models";
import DuetsVoiceSelector from "@/components/common/voice-selector/selectors/duets-voice-selector";

type DuetsVoiceSelectorModalProps = {
  selectedVoices: VoiceModel[];
  handleVoiceModelClick: (voice: VoiceModel) => void;
};

const DuetsVoiceSelectorModal = (props: DuetsVoiceSelectorModalProps) => {
  return (
    <VoiceSelectorModalBase>
      <DuetsVoiceSelector {...props} />
    </VoiceSelectorModalBase>
  );
};

export default DuetsVoiceSelectorModal;
